import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const DeviceHeartbeatService = {
  // Fetch device heartbeat logs with pagination, macId, and origin
  getHeartbeatLogs: async (
    macId,
    origin = null,
    pageNumber = 1,
    pageSize = 10,
  ) => {
    try {
      const params = new URLSearchParams();
      params.append("pageNumber", pageNumber);
      params.append("pageSize", pageSize);

      if (macId) params.append("macId", macId);
      if (origin !== null && origin !== undefined)
        params.append("origin", origin);

      const url = `/device-heartbeats/logs?${params.toString()}`;
      console.log("Fetching logs with URL:", url);

      const response = await apiService.get(url);
      console.log("API Response:", response);

      // Handle paginated response
      if (response.data && typeof response.data === "object") {
        // Check if response.data has a nested data property (API wrapping)
        const dataArray = Array.isArray(response.data.data)
          ? response.data.data
          : Array.isArray(response.data) // Or check if response.data itself is an array
          ? response.data
          : [];

        console.log("Extracted data array:", dataArray);

        return {
          data: dataArray,
          pageNumber: response.data.pageNumber || pageNumber,
          pageSize: response.data.pageSize || pageSize,
          totalRecords: response.data.totalRecords || 0,
          totalPages: response.data.totalPages || 1,
        };
      }

      return {
        data: [],
        pageNumber,
        pageSize,
        totalRecords: 0,
        totalPages: 1,
      };
    } catch (error) {
      console.error("Error fetching heartbeat logs:", error);
      throw error;
    }
  },

  getDeviceList: async () => {
    try {
      const response = await apiService.get(`/device-heartbeats/devices`);
      return response.data;
    } catch (error) {
      console.error("Error fetching device list:", error);
      throw error;
    }
  },

  getLatestDeviceStatus: async () => {
    try {
      const response = await apiService.get(
        `/device-heartbeats/devices-latest-status`,
      );
      return Array.isArray(response.data) ? response.data : [];
    } catch (error) {
      console.error("Error fetching latest device status:", error);
      throw error;
    }
  },

  // Get devices assigned to a specific campaign
  getDevicesByCampaign: async (
    campaignId,
    pageNumber = 1,
    pageSize = 10,
    onlyActiveDevices = false,
  ) => {
    try {
      // Build query string with parameters according to Swagger spec
      let url = `/devicesads/campaign/devices/by-campaign?campaignId=${campaignId}&pageNumber=${pageNumber}&pageSize=${pageSize}`;
      if (onlyActiveDevices) {
        url += `&onlyActiveDevices=${onlyActiveDevices}`;
      }

      const response = await apiService.get(url);
      return response.data;
    } catch (error) {
      console.error("Error fetching devices by campaign:", error);
      throw error;
    }
  },
};

export default DeviceHeartbeatService;
